<template>
    <div class="qingwu">
        <div class="admin_main_block">



            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="护理套餐消费数据" name="hultcxfsj">


                    <div class="admin_main_block">
                        <div class="admin_main_block_top">
                            <div class="admin_main_block_left">
                            </div>
                            <div class="admin_main_block_left">
                                <div style="width:410px;">
                                    <el-date-picker
                                            size="small"
                                            v-model="where.times"
                                            type="datetimerange"
                                            range-separator="至"
                                            start-placeholder="开始日期"
                                            end-placeholder="结束日期"
                                            :default-time="['12:00:00']"
                                    >
                                    </el-date-picker>
                                </div>
                                <div style=""><el-button icon="el-icon-search" @click="get_adv_list()">条件筛选</el-button></div>
                            </div>
                        </div>
                        <div class="admin_table_main">
                            <el-table :data="list" @selection-change="handleSelectionChange" >
                                <el-table-column type="selection"></el-table-column>
                                <el-table-column prop="F_IN_ID" label="#"  width="70px"></el-table-column>
                                <el-table-column label="金额" >
                                    <template slot-scope="scope">
                                        <div  closable="true" >{{ scope.row.F_IN_SHIJZF }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="套餐名称" >
                                    <template slot-scope="scope">
                                        <div  closable="true" >{{ scope.row.F_VR_TAOCMC }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="门店" >
                                    <template slot-scope="scope">
                                        <div  closable="true" >{{ scope.row.F_VR_MENDMC }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="护理师" >
                                    <template slot-scope="scope">
                                        <div  closable="true" >{{ scope.row.F_VR_HULS }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="F_IN_CHUANGJSJ" label="创建时间">
                                    <template slot-scope="scope">
                                        <div v-if="scope.row.F_IN_CHUANGJSJ<=0"> - </div>
                                        <div v-else>{{scope.row.F_IN_CHUANGJSJ|formatDate}}</div>
                                    </template>
                                </el-table-column>
                                <div style="margin: 0px" >{!! info->links() !!}</div>
                                <div slot="append">
                                    <div class='sum_footer xiaoji' ref='sum_xiaoji'>
                                        <div class='sum_footer_unit'></div>
                                        <div class='sum_footer_unit'></div>
                                        <div class='sum_footer_unit'></div>
                                        <div class='sum_footer_unit center' >总金额：{{zongje}}</div>
                                        <div class='sum_footer_unit center' >订单数：{{dingds}}</div>
                                        <div class='sum_footer_unit'></div>
                                        <div class='sum_footer_unit'></div>
                                        <div class='sum_footer_unit'></div>
                                        <div class='sum_footer_unit'></div>
                                    </div>
                                </div>
                            </el-table>
                            <div class="admin_table_main_pagination">
                                <el-pagination @current-change="current_change" background layout="prev, pager, next,jumper,total" :total="total_data" :page-size="page_size" :current-page="current_page"></el-pagination>
                            </div>
                        </div>
                    </div>



                </el-tab-pane>




                <el-tab-pane label="门店预约消费数据" name="mendyyxfsj">


                    <div class="admin_main_block">
                        <div class="admin_main_block_top">
                            <div class="admin_main_block_left">
                            </div>
                            <div class="admin_main_block_left">
                                <div style="width:410px;">
                                    <el-date-picker
                                            size="small"
                                            v-model="where.times"
                                            type="datetimerange"
                                            range-separator="至"
                                            start-placeholder="开始日期"
                                            end-placeholder="结束日期"
                                            :default-time="['12:00:00']"
                                    >
                                    </el-date-picker>
                                </div>
                                <div style=""><el-button icon="el-icon-search" @click="get_adv_list()">条件筛选</el-button></div>
                            </div>
                        </div>
                        <div class="admin_table_main">
                            <el-table :data="list" @selection-change="handleSelectionChange" >
                                <el-table-column type="selection"></el-table-column>
                                <el-table-column prop="F_IN_ID" label="#"  width="70px"></el-table-column>
                                <el-table-column label="金额" >
                                    <template slot-scope="scope">
                                        <div  closable="true" >{{ scope.row.F_IN_SHIJZF }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="套餐名称" >
                                    <template slot-scope="scope">
                                        <div  closable="true" >{{ scope.row.F_VR_TAOCMC }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="门店" >
                                    <template slot-scope="scope">
                                        <div  closable="true" >{{ scope.row.F_VR_MENDMC }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="护理师" >
                                    <template slot-scope="scope">
                                        <div  closable="true" >{{ scope.row.F_VR_HULS }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="F_IN_CHUANGJSJ" label="创建时间">
                                    <template slot-scope="scope">
                                        <div v-if="scope.row.F_IN_CHUANGJSJ<=0"> - </div>
                                        <div v-else>{{scope.row.F_IN_CHUANGJSJ|formatDate}}</div>
                                    </template>
                                </el-table-column>
                                <div style="margin: 0px" >{!! info->links() !!}</div>
                                <div slot="append">
                                    <div class='sum_footer xiaoji' ref='sum_xiaoji'>
                                        <div class='sum_footer_unit'></div>
                                        <div class='sum_footer_unit'></div>
                                        <div class='sum_footer_unit'></div>
                                        <div class='sum_footer_unit center' >总金额：{{zongje}}</div>
                                        <div class='sum_footer_unit center' >订单数：{{dingds}}</div>
                                        <div class='sum_footer_unit'></div>
                                        <div class='sum_footer_unit'></div>
                                        <div class='sum_footer_unit'></div>
                                        <div class='sum_footer_unit'></div>
                                    </div>
                                </div>
                            </el-table>
                            <div class="admin_table_main_pagination">
                                <el-pagination @current-change="current_change" background layout="prev, pager, next,jumper,total" :total="total_data" :page-size="page_size" :current-page="current_page"></el-pagination>
                            </div>
                        </div>
                    </div>


                </el-tab-pane>





                <el-tab-pane label="商品订单数据" name="shangpddsj">


                    <div class="admin_main_block">
                        <div class="admin_main_block_top">
                            <div class="admin_main_block_left">
                            </div>
                            <div class="admin_main_block_left">
                                <div style="width:410px;">
                                    <el-date-picker
                                            size="small"
                                            v-model="where.times"
                                            type="datetimerange"
                                            range-separator="至"
                                            start-placeholder="开始日期"
                                            end-placeholder="结束日期"
                                            :default-time="['12:00:00']"
                                    >
                                    </el-date-picker>
                                </div>
                                <div style=""><el-button icon="el-icon-search" @click="get_adv_list()">条件筛选</el-button></div>
                            </div>
                        </div>
                        <div class="admin_table_main">
                            <el-table :data="list" @selection-change="handleSelectionChange" >
                                <el-table-column type="selection"></el-table-column>
                                <!-- <el-table-column prop="id" label="#" fixed="left" width="70px"></el-table-column> -->
                                <el-table-column prop="F_IN_ID" label="#"  width="70px"></el-table-column>
                                <el-table-column label="金额" >
                                    <template slot-scope="scope">
                                        <div  closable="true" >{{ scope.row.F_IN_SHIJZF }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="订单号" >
                                    <template slot-scope="scope">
                                        <div  closable="true" >{{ scope.row.F_VR_DINGDH }}</div>
                                    </template>
                                </el-table-column>
                               <!-- <el-table-column label="商品名称" >
                                    <template slot-scope="scope">
                                        <div  closable="true" >{{ scope.row.F_VR_SHOUJH }}</div>
                                    </template>
                                </el-table-column>-->
                                <el-table-column prop="F_IN_CHUANGJSJ" label="创建时间">
                                    <template slot-scope="scope">
                                        <div v-if="scope.row.F_IN_CHUANGJSJ<=0"> - </div>
                                        <div v-else>{{scope.row.F_IN_CHUANGJSJ|formatDate}}</div>
                                    </template>
                                </el-table-column>
                                <div style="margin: 0px" >{!! info->links() !!}</div>
                                <div slot="append">
                                    <div class='sum_footer xiaoji' ref='sum_xiaoji'>
                                        <div class='sum_footer_unit'></div>
                                        <div class='sum_footer_unit'></div>
                                        <div class='sum_footer_unit'></div>
                                        <div class='sum_footer_unit center' >总金额：{{zongje}}</div>
                                        <div class='sum_footer_unit center' >订单数：{{dingds}}</div>
                                        <div class='sum_footer_unit'></div>
                                        <div class='sum_footer_unit'></div>
                                        <div class='sum_footer_unit'></div>
                                        <div class='sum_footer_unit'></div>
                                    </div>
                                </div>
                            </el-table>

                            <div class="admin_table_main_pagination">
                                <el-pagination @current-change="current_change" background layout="prev, pager, next,jumper,total" :total="total_data" :page-size="page_size" :current-page="current_page"></el-pagination>
                            </div>
                        </div>
                    </div>

                </el-tab-pane>



                <el-tab-pane label="会员卡消费数据" name="huiykxfsj">


                    <div class="admin_main_block">
                        <div class="admin_main_block_top">
                            <div class="admin_main_block_left">
                                <!--<div><router-link to="/Admin/xueyxj/form"><el-button type="primary" icon="el-icon-plus">添加</el-button></router-link></div>-->
                                <!-- <div><el-button icon="el-icon-search" @click="exports()">导出表格</el-button></div>-->
                                <!--<div><el-button icon="el-icon-search" ><router-link to="/Admin/xueyxj/forms">导入表格</router-link></el-button></div>-->
                            </div>
                            <div class="admin_main_block_left">
                                <div style="width:410px;">
                                    <el-date-picker
                                            size="small"
                                            v-model="where.times"
                                            type="datetimerange"
                                            range-separator="至"
                                            start-placeholder="开始日期"
                                            end-placeholder="结束日期"
                                            :default-time="['12:00:00']"
                                    >
                                    </el-date-picker>
                                </div>
                                <div style=""><el-button icon="el-icon-search" @click="get_adv_list()">条件筛选</el-button></div>
                            </div>
                        </div>
                        <div class="admin_table_main">
                            <el-table :data="list" @selection-change="handleSelectionChange" >
                                <el-table-column type="selection"></el-table-column>
                                <!-- <el-table-column prop="id" label="#" fixed="left" width="70px"></el-table-column> -->
                                <el-table-column prop="F_IN_ID" label="#"  width="70px"></el-table-column>
                                <el-table-column label="金额" >
                                    <template slot-scope="scope">
                                        <div  closable="true" >{{ scope.row.F_VR_XINGM }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="级别" >
                                    <template slot-scope="scope">
                                        <div  closable="true" >{{ scope.row.F_VR_XINGM }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="门店" >
                                    <template slot-scope="scope">
                                        <div  closable="true" >{{ scope.row.F_VR_SHOUJH }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="护理师" >
                                    <template slot-scope="scope">
                                        <div  closable="true" >{{ scope.row.F_VR_SHOUJH }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="F_IN_CHUANGJSJ" label="创建时间">
                                    <template slot-scope="scope">
                                        <div v-if="scope.row.F_IN_CHUANGJSJ<=0"> - </div>
                                        <div v-else>{{scope.row.F_IN_CHUANGJSJ|formatDate}}</div>
                                    </template>
                                </el-table-column>
                                <div style="margin: 0px" >{!! info->links() !!}</div>
                                <div slot="append">
                                    <div class='sum_footer xiaoji' ref='sum_xiaoji'>
                                        <div class='sum_footer_unit'></div>
                                        <div class='sum_footer_unit'></div>
                                        <div class='sum_footer_unit'></div>
                                        <div class='sum_footer_unit center' >总金额：{{zongje}}</div>
                                        <div class='sum_footer_unit center' >订单数：{{dingds}}</div>
                                        <div class='sum_footer_unit'></div>
                                        <div class='sum_footer_unit'></div>
                                        <div class='sum_footer_unit'></div>
                                        <div class='sum_footer_unit'></div>
                                    </div>
                                </div>
                            </el-table>

                            <div class="admin_table_main_pagination">
                                <el-pagination @current-change="current_change" background layout="prev, pager, next,jumper,total" :total="total_data" :page-size="page_size" :current-page="current_page"></el-pagination>
                            </div>
                        </div>
                    </div>


                </el-tab-pane>








            </el-tabs>











        </div>
    </div>
</template>

<script>
    export default {
        components: {},
        props: {},
        data() {
            return {
                list:[],
                total_data:0, // 总条数
                page_size:20,
                current_page:1,
                select_id:'',
                adv_position_id:0,
                where:{
                    type:1,
                    times:[]
                },
                info:[],
                activeName:'hultcxfsj',
                zongje:0,
                dingds:0,
            };
        },
        watch: {},
        computed: {},
        methods: {
            handleClick:function(){

                console.log('类型类型')
                console.log(this.activeName)
                console.log('类型类型')

                if(this.activeName == 'hultcxfsj'){
                    this.hultcxfsj();
                }
                if(this.activeName == 'mendyyxfsj'){
                    this.mendyyxfsj();
                }
                if(this.activeName == 'shangpddsj'){
                    this.shangpddsj();
                }
                if(this.activeName == 'huiykxfsj'){
                    this.huiykxfsj();
                }
            },
            handleSelectionChange:function(e){
                let ids = [];
                e.forEach(v => {
                    ids.push(v.F_IN_ID);
                });
                this.select_id = ids.join(',');
            },
            hultcxfsj:function(){
                let where = {};
                where.page = this.current_page;
                where.params = this.where;
                where.params.type =1;
                this.where.page = this.current_page;
                this.$get(this.$api.getMendjysjList,where).then(res=>{
                    this.page_size = res.data.data.per_page;
                    this.total_data = res.data.data.total;
                    this.current_page = res.data.data.current_page;
                    this.list = res.data.data.data;
                    this.zongje = res.data.zongje;
                    this.dingds = res.data.dingds;
                })
            },
            mendyyxfsj:function(){
                let where = {};
                where.page = this.current_page;
                where.params = this.where;
                where.params.type =2;
                this.where.page = this.current_page;
                this.$get(this.$api.getMendjysjList,where).then(res=>{
                    this.page_size = res.data.data.per_page;
                    this.total_data = res.data.data.total;
                    this.current_page = res.data.data.current_page;
                    this.list = res.data.data.data;
                    this.zongje = res.data.zongje;
                    this.dingds = res.data.dingds;
                })
            },
            shangpddsj:function(){
                let where = {};
                where.page = this.current_page;
                where.params = this.where;
                where.params.type =3;
                this.where.page = this.current_page;
                this.$get(this.$api.getMendjysjList,where).then(res=>{
                    this.page_size = res.data.data.per_page;
                    this.total_data = res.data.data.total;
                    this.current_page = res.data.data.current_page;
                    this.list = res.data.data.data;
                    this.zongje = res.data.zongje;
                    this.dingds = res.data.dingds;
                })
            },
            huiykxfsj:function(){
                let where = {};
                where.page = this.current_page;
                where.params = this.where;
                where.params.type =4;
                this.where.page = this.current_page;
                this.$get(this.$api.getMendjysjList,where).then(res=>{
                    this.page_size = res.data.data.per_page;
                    this.total_data = res.data.data.total;
                    this.current_page = res.data.data.current_page;
                    this.list = res.data.data.data;
                    this.zongje = res.data.zongje;
                    this.dingds = res.data.dingds;
                })
            }
        },
        created() {
            this.hultcxfsj();
            /*this.get_ruktz();*/
        },
        mounted() {}
    };
</script>
<style lang="scss" scoped>
    .table_dl_dd_all{
        height: 50px;
        overflow: hidden;
    }
    .sum_footer{
        display:flex;
        display:-webkit-flex;
        line-height:50px;
        color:#606266;
    }
    .sum_footer_unit{
        flex-grow:1;
        -webkit-flex-grow:1;
        text-indent:10px;
        font-size:14px;
        font-weight:bold;
    }
    .sum_footer_unit.center{
        text-align:center;
    }
    .sum_footer.xiaoji{
        border-bottom:1px solid #EBEEF5;
    }

    .admin_main_block_left div {
        float: left;
        margin-right: 2px;
    }

    .el-range-editor--small .el-range-input {
        font-size: 13px;
        width: 120px;
    }
</style>
